"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./styles");

var _responsive = require("../responsive");

var _cobrandDefault = _interopRequireDefault(require("../../assets/cobrand-default.svg"));

var _twitter = _interopRequireDefault(require("../../assets/icons/twitter.svg"));

var _instagram = _interopRequireDefault(require("../../assets/icons/instagram.svg"));

var _facebook = _interopRequireDefault(require("../../assets/icons/facebook.svg"));

var _reactIntl = require("react-intl");

var _intlFormat = require("../../lib/intl-format");

var _translations = _interopRequireDefault(require("./translations"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Footer,
    boundMethodCheck = function boundMethodCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new Error('Bound instance method accessed before binding');
  }
};

var _default = (0, _intlFormat.withTranslations)(_translations.default, Footer = function () {
  var Footer =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(Footer, _React$Component);

    function Footer() {
      var _this;

      _classCallCheck(this, Footer);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Footer).apply(this, arguments));
      _this.switchLocale = _this.switchLocale.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(Footer, [{
      key: "switchLocale",
      value: function switchLocale(evt) {
        var base, ref;
        boundMethodCheck(this, Footer);
        return typeof (base = this.props).switchLocale === "function" ? base.switchLocale((evt != null ? (ref = evt.target) != null ? ref.value : void 0 : void 0) || evt) : void 0;
      } // render funtions

    }, {
      key: "render",
      value: function render() {
        return _react.default.createElement("footer", {
          className: "Footer"
        }, _react.default.createElement("div", {
          className: "footer-container"
        }, _react.default.createElement("div", {
          className: "links"
        }, this.about(), this.attendee(), this.host(), this.locale()), _react.default.createElement("div", {
          className: "copyright"
        }, this.logo(), this.pptou(), this.socialMedia())));
      }
    }, {
      key: "logo",
      value: function logo() {
        return _react.default.createElement("a", {
          className: "logo",
          href: "/"
        }, _react.default.createElement(_cobrandDefault.default, null));
      }
    }, {
      key: "pptou",
      value: function pptou() {
        return _react.default.createElement("div", {
          className: "pp-tou"
        }, _react.default.createElement("a", {
          href: "/terms"
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.footer.terms_and_conditions",
          defaultMessage: "Terms and Conditions"
        })), _react.default.createElement(_responsive.FromTablet, null, "|"), _react.default.createElement("a", {
          href: "/terms-of-use"
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.footer.terms_of_use",
          defaultMessage: "Terms of Use"
        })), _react.default.createElement(_responsive.FromTablet, null, "|"), _react.default.createElement("a", {
          href: "/privacy"
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.footer.privacy_policy",
          defaultMessage: "Privacy policy"
        })), _react.default.createElement("span", null, "\xA9 Universe ", new Date().getFullYear()));
      }
    }, {
      key: "socialMedia",
      value: function socialMedia() {
        return _react.default.createElement("div", {
          className: "social-media"
        }, _react.default.createElement("a", {
          href: "https://twitter.com/uniiverse"
        }, _react.default.createElement(_twitter.default, null)), _react.default.createElement("a", {
          href: "https://instagram.com/universe"
        }, _react.default.createElement(_instagram.default, null)), _react.default.createElement("a", {
          href: "https://facebook.com/universe"
        }, _react.default.createElement(_facebook.default, null)));
      }
    }, {
      key: "about",
      value: function about() {
        return _react.default.createElement("section", {
          className: "about"
        }, _react.default.createElement("header", null, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.footer.get_to_know_us",
          defaultMessage: "Get to know us"
        })), _react.default.createElement("a", {
          href: "/about"
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.footer.about",
          defaultMessage: "About"
        })), _react.default.createElement("a", {
          href: "https://careers.universe.com"
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.footer.jobs",
          defaultMessage: "Jobs"
        })), _react.default.createElement("a", {
          href: "https://blog.universe.com"
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.footer.blog",
          defaultMessage: "Blog"
        })), _react.default.createElement("a", {
          href: "/help"
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.footer.get_help",
          defaultMessage: "Get help"
        })), _react.default.createElement("a", {
          href: "/contact-us"
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.footer.contact_us",
          defaultMessage: "Contact us"
        })));
      }
    }, {
      key: "attendee",
      value: function attendee() {
        return _react.default.createElement("section", {
          className: "attendee"
        }, _react.default.createElement("header", null, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.footer.find_events",
          defaultMessage: "Find events"
        })), _react.default.createElement("a", {
          href: "/explore"
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.footer.top_events",
          defaultMessage: "Top events"
        })));
      }
    }, {
      key: "host",
      value: function host() {
        return _react.default.createElement("section", {
          className: "host"
        }, _react.default.createElement("header", null, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.footer.host_events",
          defaultMessage: "Host events"
        })), _react.default.createElement("a", {
          href: "/overview"
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.footer.become_a_host",
          defaultMessage: "Become a host"
        })), _react.default.createElement("a", {
          href: "/features"
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.footer.tour",
          defaultMessage: "Tour"
        })), _react.default.createElement("a", {
          href: "/sell-tickets-on-your-website-with-universe-widgets"
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.footer.embeddable_widgets",
          defaultMessage: "Embeddable Widgets"
        })), _react.default.createElement("a", {
          href: "/customers"
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.footer.customers",
          defaultMessage: "Customers"
        })), _react.default.createElement("a", {
          href: "/pricing"
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.footer.pricing",
          defaultMessage: "Pricing"
        })), _react.default.createElement("a", {
          href: "/ticketmanager"
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.footer.get_the_onsite_app",
          defaultMessage: "Get the onsite app"
        })), _react.default.createElement("a", {
          href: "https://developers.universe.com"
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.footer.developers",
          defaultMessage: "Developers"
        })));
      }
    }, {
      key: "locale",
      value: function locale() {
        var key, ref, val;
        return _react.default.createElement("section", {
          className: "locale"
        }, _react.default.createElement("select", {
          onChange: this.switchLocale,
          value: ((ref = this.props.intl) != null ? ref.locale : void 0) || 'en'
        }, function () {
          var ref1, results;
          ref1 = this.props.locales;
          results = [];

          for (key in ref1) {
            val = ref1[key];
            results.push(_react.default.createElement("option", {
              key: key,
              value: key
            }, val));
          }

          return results;
        }.call(this)));
      }
    }]);

    return Footer;
  }(_react.default.Component);

  ;
  Footer.propTypes = {
    locales: _propTypes.default.object,
    switchLocale: _propTypes.default.func
  };
  return Footer;
}.call(void 0));

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@uniiverse/library/components/footer/index.js
// module id = 1568
// module chunks = 0 1 2 4 5 6 7 8 9 10 11 12 13 14 15 16